<template>
  <el-dialog
    :visible="innerVisible"
    width="800px"
    :title="dialogTitle"
    @close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column
        v-for="(column, index) in columns"
        :key="index"
        :prop="column.prop"
        :label="column.label"
      />
    </el-table>

    <!-- 分页 -->
    <el-row
      style="margin-top: 20px"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <el-col :span="6" style="text-align: left"></el-col>
      <el-col :span="18" style="text-align: right">
        <el-pagination
          layout="prev, pager, next, jumper"
          :total="totalItems"
          :page-size="pageSize"
          :current-page.sync="localCurrentPage"
          @current-change="handlePageChange"
        />
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  name: "ViewDialog",
  props: {
    totalItems: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    dialogTitle: {
      type: String,
      default: "物资详情",
    },
    tableData: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 2,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      innerVisible: this.visible, // 创建本地副本
      localCurrentPage: this.currentPage, // 用本地变量代替直接修改
    };
  },
  watch: {
    visible(val) {
      this.innerVisible = val; // 父组件变化时同步更新
    },
    // 当 prop 改变时同步更新本地变量
    currentPage(val) {
      this.localCurrentPage = val;
    },
  },
  methods: {
    handleClose() {
      this.innerVisible = false;
      this.$emit("update:visible", false);
    },
    handlePageChange(page) {
      this.localCurrentPage = page;
      this.$emit("page-change", page);
    },
  },
};
</script>

<style scoped>
.el-dialog {
  padding: 20px;
}
</style>
